import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { activateFirebaseSession } from "../firebase";

const APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbw-IoJ5jSgq81KngMezTKJTC6cf8bzK1SHUXQxSuUD9K_K75dcQK-cTn34MqhdqYdOq/exec";

const jsonpFetch = (url, params) => {
  return new Promise((resolve, reject) => {
    const callbackName = "gsheetCallback_" + Date.now();
    const timeout = setTimeout(() => {
      cleanup();
      reject(new Error("Request timed out"));
    }, 10000);

    const cleanup = () => {
      delete window[callbackName];
      const script = document.getElementById(callbackName);
      if (script) script.remove();
      clearTimeout(timeout);
    };

    window[callbackName] = (data) => {
      cleanup();
      resolve(data);
    };

    const queryString = new URLSearchParams({
      ...params,
      callback: callbackName,
    }).toString();

    const script = document.createElement("script");
    script.id = callbackName;
    script.src = `${url}?${queryString}`;
    script.onerror = () => {
      cleanup();
      reject(new Error("Script load error"));
    };

    document.body.appendChild(script);
  });
};

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const userData = localStorage.getItem("userDATA");
    if (userData) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = await jsonpFetch(APPS_SCRIPT_URL, { email, password });

      if (data.success) {
        const userData = {
          name: data.name,
          role: data.role,
          email: data.email,
        };
        localStorage.setItem("userDATA", JSON.stringify(userData));
          await activateFirebaseSession(); // 🔑 Activate Firebase session
        navigate("/dashboard");
      } else {
        setError(data.message || "Invalid credentials");
      }
    } catch (err) {
      setError("Connection failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <h1 className="login-title">Forza Logistics</h1>
        <p className="login-subtitle">Secure Access Portal</p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <input
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label>Email Address</label>
          </div>

          <div className="input-group">
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label>Password</label>
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {error && <p style={{ color: "#CE4735", marginTop: "10px" }}>{error}</p>}
      </div>
    </div>
  );
};

export default Login;